module.exports = __webpack_public_path__ + "static/media/059c3056cca560f88a6bf8af861752b4.059c3056.ttf";